import { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { EventWrapperProps } from 'react-big-calendar';
import { FaSuitcase } from 'react-icons/fa';

import { useModal } from 'store/modal';

import { getEventStyle } from 'utils/helpers/work-trips';
import handlePreviewDoc from 'utils/helpers/handlePreviewDoc';

import TooltipWrapper from 'components/TooltipWrapper';

interface Props extends EventWrapperProps {
  event: any;
  continuesAfter?: boolean;
}

const getActiveDocumentId = (event: any): number | null => {
  if (String(event.status || '').startsWith('report_') && event.report_document_id) {
    return event.report_document_id;
  }
  return event.order_document_id || event.report_document_id || null;
};

const CalendarEventWrapper: FC<Props> = ({ event }: Props) => {
  const { t } = useTranslation();
  const { showModal } = useModal();

  const activeDocumentId = getActiveDocumentId(event);

  const eventOverlay = (
    <span>
      {event.user_name} {' - '} {t(`workTrips.statuses.${event.status}`)}
      {event.displayed_destination && (
        <>
          <br />
          {t('workTrips.destination')}: {event.displayed_destination}
        </>
      )}
      {event.route && (
        <>
          <br />
          {t('workTrips.route')}: {event.route}
        </>
      )}
      {event.task && (
        <>
          <br />
          {t('workTrips.task')}: {event.task}
        </>
      )}
    </span>
  );

  return (
    <TooltipWrapper
      id="tooltip-work-trips-calendar-event"
      overlay={eventOverlay}
      wrapperClass="d-block w-100"
    >
      <div
        className="d-flex justify-content-between pr-2 pl-2 w-100"
        style={{ ...getEventStyle(event), cursor: activeDocumentId ? 'pointer' : 'default' }}
        onClick={() => activeDocumentId && handlePreviewDoc({ showModal, id: activeDocumentId })}
      >
        <EventName className="mb-0">
          <FaSuitcase
            color={getEventStyle(event)?.color}
            size={14}
          />{' '}
          {event.user_name}
        </EventName>
      </div>
    </TooltipWrapper>
  );
};

export default CalendarEventWrapper;

const EventName = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
